function pad(e) {
    return ("0" + parseInt(e)).substr(-2);
}

function tick() {
    var e = new Date();
    e.setHours(14, 0, 0);
    var t = new Date();
    if (t > e)
        return (
            e.setDate(e.getDate() + 1),
            new Flickity(".announcement-slider").remove(document.getElementById("AnnouncementSlide-CountdownTimer")),
            document.getElementById("fera-purchase-count") && (document.getElementById("fera-purchase-count").style.display = "block"),
            document.getElementById("product-countdown-wrapper") && (document.getElementById("product-countdown-wrapper").style.display = "none"),
            !1
        );
    var n = (e - t) / 1e3,
        o = pad((n / 60 / 60) % 60),
        i = pad((n / 60) % 60),
        f = '🚛 Innerhalb von',
        l = '. bestellen für Lieferung am nächsten Tag ⏰';
    document.getElementById("product-countdown-time") && (document.getElementById("product-countdown-time").innerHTML = 
    "00" == o ? f + ' ' + i + " mins" + ' ' + l : "01" == o ? f + ' ' + o + " hr " + i + " mins" + l : f + ' ' + o + " hrs " + i + " mins" + l),
    document.getElementById("announcement-countdown-time") && (document.getElementById("announcement-countdown-time").innerHTML = 
    "00" == o ? f + ' ' + i + " mins" + ' ' + l : "01" == o ? f + ' ' + o + " hr " + i + " mins" + l : f + ' ' + o + " hrs " + i + " mins" + l);


}
tick();

// Custom fix Gift Message
document.addEventListener('DOMContentLoaded', function () {
    const giftMessage = document.querySelector('#gift_message');
    const giftMessageCharsLeft = document.querySelector('.gift_message_chars_left');
    giftMessage?.addEventListener("keyup", (event) => {
        const lengthGiftMessage = event.target.value.length;
        if(lengthGiftMessage <=100 ){
            giftMessageCharsLeft.textContent = 100 - lengthGiftMessage
        }
    });
})

function change_card(e, t) {
    e.scrollIntoView({ behavior: "smooth", inline: "center", block: "center" });
    const n = document.getElementsByClassName("giftcard-not-selected-bg");
    for (i = 0, k = n.length; i < k; i++) n[i].classList.remove("hidden");
    var o = !0;
    "No Personalisation" == e.dataset.value && (o = !1);
    const c = document.getElementsByClassName("gift_message_wrapper")[t];
    if (o) c.classList.remove("hidden");
    else {
        const e = document.getElementsByClassName("gift_message_text_box")[t],
            n = document.getElementsByClassName("gift_message_chars_left")[t];
        (e.value = ""), (n.innerHTML = 100), c.classList.add("hidden");
    }
}

// function init_gift_message() {
//     tick();
//     const e = document.getElementsByClassName("giftcard"),
//         t = document.getElementsByName("id");
//     var n = t[0],
//         o = 0;
//     t.length > 1 && ((n = t[1]), (o = 1));
//     for (var i = 0, c = e.length; i < c; i++)
//         e[i].addEventListener("click", function () {
//             change_card(this, o);
//         });
//     if (t) {
//         const e = n[n.selectedIndex];
//         if (!e.text.includes("No Personalisation")) {
//             const t = document.getElementById(e.value);
//             document.getElementsByClassName("gift_message_wrapper")[o].classList.remove("hidden"), t.scrollIntoView({ behavior: "smooth", inline: "center", block: "center" });
//         }
//     }
//     document.getElementsByClassName("gift_message_text_box")[o].addEventListener("keyup", function () {
//         document.getElementsByClassName("gift_message_chars_left")[o].innerHTML = 100 - this.value.length;
//     });
// }
// if ((document.addEventListener("DOMContentLoaded", tick), document.getElementById("activate_giftcards"))) {
//     "true" === document.getElementById("activate_giftcards").value && init_gift_message();
// }



function doughnut_time_rewards() {
    Smile.ready()
        .then((e) => {
            document.getElementById("dt-points") && (document.getElementById("dt-points").innerHTML = Smile.customer.points_balance);
            const t = new Proxy(new URLSearchParams(window.location.search), { get: (e, t) => e.get(t) });
            t.referral_activity && (localStorage.referralActivity = t.referral_activity),
                localStorage.referralActivity &&
                    "none" !== localStorage.referralActivity &&
                    (console.log("Referral Activity ID: " + localStorage.referralActivity),
                    Smile.createActivity({ token: localStorage.referralActivity })
                        .then(function (e) {
                            Smile.fetchCustomer()
                                .then((e) => {
                                    (localStorage.referralActivity = "none"),
                                        console.log("Added points"),
                                        setTimeout(function () {
                                            document.getElementById("dt-points") && (document.getElementById("dt-points").innerHTML = Smile.customer.points_balance);
                                        }, 5e3);
                                })
                                .catch(function (e) {
                                    console.log("Couldn't fetch customer");
                                });
                        })
                        .catch(function (e) {
                            console.log("Not logged in or something went wrong");
                        }));
        })
        .catch((e) => {
            console.log("Smile failed to load");
        });
}
window.SmileUI
    ? doughnut_time_rewards()
    : document.addEventListener("smile-ui-loaded", () => {
          doughnut_time_rewards();
      });
